import React, { useState, useEffect } from 'react';
import './Hero.css';
import heroImage from '../images/hero.jpg';
import { heroService } from '../services/heroService';
import { supabase } from '../supabaseClient';
import videohero from '../images/1002.mp4';
import LogoCarousel from './LogoCarousel';

function Hero({ onNavigate }) {
  const [heroData, setHeroData] = useState({
    badge: { date: '', location: '' },
    title: '',
    subtitle: '',
    description: '',
    primaryButton: { text: '', action: 'participation' },
    secondaryButton: { text: '', action: 'learn-more', visible: false },
    backgroundImage: '',
    scrollIndicator: { visible: true, text: 'SCROLL' }
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Announcement to display in the hero (multiline, preserves line breaks)
  const announcement = `Merci d’avoir fait de l’édition 2025 un succès exceptionnel !
Rendez-vous du 2 au 5 novembre 2026 pour la prochaine édition du CIGSIDA.
Une nouvelle année de rencontres, d’échanges et d’innovations vous attend.
Restez connectés : plus d’informations arrivent très bientôt.`;

  useEffect(() => {
    loadHeroData();
  }, []);

  const loadHeroData = async () => {
    try {
      setLoading(true);
      // Get active edition first
      const { data: activeEdition } = await supabase
        .from('editions')
        .select('year')
        .eq('is_active', true)
        .single();
      
      let editionYear = '2025'; // Default fallback
      if (activeEdition) {
        editionYear = activeEdition.year;
      }

      const data = await heroService.getHeroData(editionYear);
      
      if (data) {
        setHeroData(data);
      } else {
        // Use default data if none found
        console.warn('No hero data found, using defaults');
      }
      setError(null);
    } catch (error) {
      console.error('Error loading hero data:', error);
      setError('Failed to load hero data');
      // Keep default heroData state
    } finally {
      setLoading(false);
    }
  };

  const scrollToContent = () => {
    window.scrollTo({
      top: window.innerHeight,
      behavior: 'smooth'
    });
  };

  const handlePrimaryButtonClick = () => {
    console.log('Button clicked, onNavigate:', onNavigate);
    if (onNavigate) {
      console.log('Navigating to', heroData.primaryButton.action);
      onNavigate(heroData.primaryButton.action);
    } else {
      console.error('onNavigate function not provided');
    }
  };

  const handleSecondaryButtonClick = () => {
    if (onNavigate) {
      onNavigate(heroData.secondaryButton.action);
    }
  };

  if (loading) {
    return (
      <section className="hero" >   <video
        className="hero-video"
        autoPlay
        loop
        muted
        playsInline
        style={{ position: 'absolute', width: '100%', height: '100%', objectFit: 'cover', zIndex: 0 }}
      >
        
        {/* <source src={heroData.backgroundImage || ''} type="video/mp4" /> */}
        <source src={videohero} type="video/mp4" />
       
       
      </video>
        <div className="hero-overlay">
          <div className="hero-container">
            <div className="hero-content">
              {/* Replace text with animated loading spinner */}
              <div className="loading-spinner"></div>
            </div>
          </div>
        </div>
        
      </section>
      
    );
  }

  return (
    <>
    <section className="hero">
      {/* Video background */}
      <video
        className="hero-video"
        autoPlay
        loop
        muted
        playsInline
        style={{ position: 'absolute', width: '100%', height: '100%', objectFit: 'cover', zIndex: 0 }}
      >
        {/* <source src={heroData.backgroundImage || ''} type="video/mp4" /> */}
        <source src={videohero} type="video/mp4" />
       
       
      </video>
      <div className="hero-overlay">
        <div className="hero-container">
          <div className="hero-content">
            <div className="hero-badge">
              <span className="hero-date">{heroData.badge.date}</span>
              <span className="hero-location">{heroData.badge.location}</span>
            </div>
            
            <h1 className="hero-title">
              {heroData.title}
              <span className="hero-subtitle">{heroData.subtitle}</span>
            </h1>
            
            {heroData.description && (
              <p className="hero-description">
                {heroData.description}
              </p>
            )}

            {/* Announcement block (preserves blank lines) */}
            {announcement && (
              <div className="hero-announcement" aria-live="polite">
                {announcement.split('\n').map((line, idx) =>
                  line.trim() === '' ? <br key={idx} /> : <p key={idx}>{line}</p>
                )}
              </div>
            )}
            
            {/* <div className="hero-actions">
              <button className="hero-btn primary" onClick={handlePrimaryButtonClick}>
                {heroData.primaryButton.text}
              </button>
              {heroData.secondaryButton.visible && (
                <button className="hero-btn secondary" onClick={handleSecondaryButtonClick}>
                  {heroData.secondaryButton.text}
                </button>
              )}
            </div> */}
            
            {/* <p className="hero-conference-info">
              Les conférences du congrès sont publiques, sous réserve d'une inscription préalable et la réception par e-mail, d'une invitation.
            </p> */}
          </div>
        </div>
        
        {heroData.scrollIndicator.visible && (
          <div className="scroll-indicator" onClick={scrollToContent}>
            <span className="scroll-text">{heroData.scrollIndicator.text}</span>
            <div className="scroll-arrow"></div>
          </div>
        )}
      </div>
   
    </section>
       <LogoCarousel  />
       </>
  );
}

export default Hero;
